import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer, createTransform } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { rootReducer } from "./root.reducer";

const excludeTokenTransform = createTransform(
    (inboundState: any) => {
        const { token, ...rest } = inboundState;
        return rest;
    },
    (outboundState: any) => {
        return { ...outboundState, token: '' };
    },
    { whitelist: ['userReducer'] }
);

const persistConfig = {
    key: "root",
    storage,
    whitelist:['userReducer', 'cacheReducer'],
    transforms: [excludeTokenTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({ serializableCheck: false });
    },
});
export let persistor = persistStore(store);
